module.exports = __webpack_public_path__ + "img/death.77795246.svg";